// extracted by mini-css-extract-plugin
module.exports = {"container":"_KNB7-rZb"};